export const coffeeItems = [
  {
    id: 1,
    name: 'Cappuccino',
    description: 'Rich espresso with steamed milk foam and a dusting of cocoa',
    type: 'Hot Coffee',
    price: '₹315',
    imagePath: '/images/cappuccino.jpg',
    gradient: 'linear-gradient(135deg, #8B4513 0%, #D2691E 100%)'
  },
  {
    id: 2,
    name: 'Latte',
    description: 'Smooth espresso with velvety steamed milk and delicate foam',
    type: 'Hot Coffee',
    price: '₹280',
    imagePath: '/images/latte.jpg',
    gradient: 'linear-gradient(135deg, #A0826D 0%, #C9A88E 100%)'
  },
  {
    id: 3,
    name: 'Americano',
    description: 'Bold espresso diluted with hot water for a smooth finish',
    type: 'Hot Coffee',
    price: '₹245',
    imagePath: '/images/americano.jpg',
    gradient: 'linear-gradient(135deg, #654321 0%, #8B6914 100%)'
  },
  {
    id: 4,
    name: 'Espresso',
    description: 'Pure concentrated coffee shot with intense flavor',
    type: 'Hot Coffee',
    price: '₹210',
    imagePath: '/images/espresso.jpg',
    gradient: 'linear-gradient(135deg, #3E2723 0%, #5D4037 100%)'
  },
  {
    id: 5,
    name: 'Mocha',
    description: 'Espresso with rich chocolate sauce and steamed milk',
    type: 'Hot Coffee',
    price: '₹350',
    imagePath: '/images/mocha.jpg',
    gradient: 'linear-gradient(135deg, #6F4E37 0%, #A0522D 100%)'
  },
  {
    id: 6,
    name: 'Macchiato',
    description: 'Espresso marked with a dollop of velvety foam',
    type: 'Hot Coffee',
    price: '₹263',
    imagePath: '/images/macchiato.jpg',
    gradient: 'linear-gradient(135deg, #8B7355 0%, #A68B6C 100%)'
  },
  {
    id: 7,
    name: 'Flat White',
    description: 'Velvety microfoam with double shot espresso',
    type: 'Hot Coffee',
    price: '₹298',
    imagePath: '/images/flatwhite.jpg',
    gradient: 'linear-gradient(135deg, #C8B299 0%, #E5D4C1 100%)'
  },
  {
    id: 8,
    name: 'Cold Brew',
    description: 'Smooth cold-steeped coffee served over ice',
    type: 'Iced Coffee',
    price: '₹315',
    imagePath: '/images/coldbrew.jpg',
    gradient: 'linear-gradient(135deg, #4A3728 0%, #6B5344 100%)'
  }
];
